import auth from "./auth";
import api from "./api";

const MERCHANT_BASE_SERVICE_URL = "merchant-service";

export default {
    checkSubdomain(param) {
        return new Promise((resolve, reject) => {
            api.post(
                `${MERCHANT_BASE_SERVICE_URL}/cms/subdomain/exist`,
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getSubdomainUrlList(param) {
        return new Promise((resolve, reject) => {
            api.post(
                MERCHANT_BASE_SERVICE_URL + "/cms/subdomain/list",
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    console.log(error);
                    reject(status, error);
                });
        });
    },
    updateSubdomain(param) {
        return new Promise((resolve, reject) => {
            api.post(
                `${MERCHANT_BASE_SERVICE_URL}/cms/subdomain/save`,
                param.payload,
                auth.getHeader()
            )
                .then(response => {
                    return resolve(response);
                })
                .catch((status, error) => {
                    reject(status, error);
                });
        });
    },
    getGoogleTagManager() {
        return new Promise((resolve, reject) => {
            api.get(
                `${MERCHANT_BASE_SERVICE_URL}/v1/cms/analytics/code/view`,
                auth.getHeader()
            )
                .then(response => resolve(response))
                .catch((status, error) => reject(status, error));
        });
    },
    saveGoogleTagManage(payload) {
        return new Promise((resolve, reject) => {
            api.post(
                `${MERCHANT_BASE_SERVICE_URL}/v1/cms/analytics/code/save`,
                payload,
                auth.getHeader()
            )
                .then(response => resolve(response))
                .catch((status, error) => reject(status, error));
        });
    }
};
